import VariantsThresholdListPage from '../VariantsThreshold/VariantsThresholdListPage';

/**
 * Process Level Threshold.
 *
 * Same grid as the store level page (Variants Threshold) — the `thresholdLevel`
 * prop swaps the Asset picker for a Process picker and scopes every read and
 * write to `ProcessProductVariantThreshold` (`?processId=`) instead of the
 * store table. These are the thresholds the threshold based auto indent job
 * (uy-qc-report-service `AutomaticProcessIndentOrderJob`) tops a process up to.
 */
const ProcessThresholdListPage = () => {
	return <VariantsThresholdListPage thresholdLevel='PROCESS' />;
};

export default ProcessThresholdListPage;
